import { Localisation } from './localisation';

export const StepList = ['days', 'year'] as const; //, 'weeks', 'months'
export type Steps = typeof StepList[number] | 'weeks' | 'months';
export type StepsLocalisation = Localisation<Steps>;
